import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const LogoutIcon: React.FC<Props> = ({ color }) => {
	return (
		<svg
			role="img"
			aria-label="Logout"
			width="27"
			height="26"
			viewBox="0 0 27 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 10V2C8 1.44772 8.44772 1 9 1H25C25.5523 1 26 1.44772 26 2V24C26 24.5523 25.5523 25 25 25H9C8.44772 25 8 24.551 8 23.9987C8 20.6339 8 19.1617 8 16"
				stroke={getColor(color)}
				strokeLinecap="round"
			/>
			<path d="M1 13H15" stroke={getColor(color)} strokeLinecap="round" />
			<path
				d="M12 9L15.2929 12.2929C15.6834 12.6834 15.6834 13.3166 15.2929 13.7071L12 17"
				stroke={getColor(color)}
				strokeLinecap="round"
			/>
		</svg>
	);
};
